export default "__VITE_ASSET__DnnhYmtc__"